import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from "@material-ui/core/Typography/Typography";
import {makeStyles} from "@material-ui/core/styles/index";
import {ItemTile} from "./ItemTile";
import useInitialOffer from "./Components/Item/UseInitialOffer";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        borderTop: '1px solid #ccc'
    },
    card: {
        width: '100%',
        display: 'flex',
        //backgroundColor: '#f2f8fd',
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor1: 'azure',
        },
        marginBottom: 1,
        cursor: 'pointer',
        borderRadius: 0,
    },
    cover: {
        width: 230,
        minWidth: 230,
        marginBottom: -4,
        background: '#eee'
    },
    coverMobile: {
        width: 100,
        minWidth: 100,
        marginBottom: -4
    },
    h: {
        fontSize: '1rem'
    },
    hMobile: {
        fontSize: '1rem',
        overflow: 'hidden',
        maxHeight: 25,
        height: 25,
    },
    content: {
        paddingTop: 5,
        paddingBottom: 0,
        paddingRight: 5,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    hint: {

    },
    hintMobile: {
        maxHeight: 20,
        overflow: 'hidden'
    },

}));

export function SelectedItems(props) {

    const classes = useStyles();

    const useOffer = useInitialOffer();

    const items = props.items;
    const isMobile = props.isMobile;
    const titleLength = 135;

    return <div className={classes.root}>
        {items.map(item => {
            return <Card className={classes.card} onClick={(e) => {e.preventDefault();props.handleClick(item, props.returnRoute)}}>
                <div className={isMobile ? classes.coverMobile : classes.cover}>
                    <ItemTile item={item} isMobile={isMobile} handleClick={props.handleClick} micro={isMobile}
                    returnRoute={props.returnRoute}/>
                </div>
                <div className={classes.details}>
                    <CardContent className={classes.content}>
                        <Typography component="h6" variant="h6"
                                    className={isMobile ? classes.hMobile : classes.h}>
                            {(item.year ? item.year + " " : "")
                            + (item.title.length > titleLength ? item.title.substr(0, titleLength)+'...' : item.title)}
                        </Typography>

                        {isMobile ? <>
                            <Typography
                                        className={props.isMobile ? classes.rowMobile : classes.row}>
                                <strike>${new Intl.NumberFormat().format((item.price) / 100)}</strike> ·
                                <b>${new Intl.NumberFormat().format((useOffer.getOffer(item.price))/100)}</b> with offer
                            </Typography>
                            <Typography className={props.isMobile ? classes.hintMobile : classes.hint}>
                                {item.hint}
                            </Typography>
                        </> : <>
                            <Typography variant="subtitle1" color="textSecondary"
                                        className={props.isMobile ? classes.rowMobile : classes.row}>
                                Stock: {item.sn}
                            </Typography>
                            <Typography
                                        className={props.isMobile ? classes.rowMobile : classes.row}>
                                Buy now: <strike>${new Intl.NumberFormat().format(item.price / 100)}</strike>
                            </Typography>
                            <Typography variant="subtitle1"
                                        className={props.isMobile ? classes.rowMobile : classes.row}>
                               With offer: <b>${new Intl.NumberFormat().format((useOffer.getOffer(item.price))/100)}</b>
                            </Typography>
                            <Typography variant="subtitle1"
                                        className={props.isMobile ? classes.rowMobile : classes.row}>
                                Location: {item.city}, {item.state}
                            </Typography>
                            <Typography className={props.isMobile ? classes.hintMobile : classes.hint}>
                                {item.hint}
                            </Typography>
                        </>
                        }

                    </CardContent>
                </div>
            </Card>
        })}</div>
}